import useCaseSummaryHeader from '../hooks/useCaseSummaryHeader';
import SplitDropdownButton from './ui-control/SplitDropdownButton';
import { pageTitleClasses } from './common/PageTitle';

// Stone chips at 24px, per the Arches case header; they read as quiet metadata
// rather than the teal call-to-action the mint fill implied.
const customBadgeClasses =
    "flex items-center justify-center w-auto gap-2 h-6 px-2.5 " +
    "text-[10px]! font-normal! uppercase tracking-wide rounded border-0 " +
    "bg-surface-alt! text-content!";

const ownerBadgeClasses =
    "group/owner relative bg-surface-alt text-body " +
    "w-6 h-6 flex items-center justify-center cursor-default " +
    "text-[calc(var(--spacing)*2.5)]! font-normal!";

const ownerTooltipClasses =
    "absolute bottom-[120%] left-1/2 [transform:translateX(-50%)] bg-surface " +
    "border border-border py-1.5 px-2.5 rounded-md " +
    "shadow-[0px_2px_6px_rgba(0,0,0,0.1)] whitespace-nowrap " +
    "hidden group-hover/owner:block z-10 " +
    "font-sans text-sm leading-[calc(var(--spacing)*5.25)]";

const tooltipLabelClasses = "text-subtle font-normal";
const tooltipNameClasses = "font-bold text-content";

const CaseSummaryHeader = ({ caseId, caseData }) => {
    const { ownerFullName, initials, menuItems, isOpen, toggle, caseTypeText } = useCaseSummaryHeader({ caseId, caseData });

    return (
        <div className="mb-6">
            <div className="mb-4">
                <div className="flex items-center justify-between gap-2 mb-1 flex-wrap">
                    <h2 className={`${pageTitleClasses} mt-0! mb-0!`}>{caseData?.caseInfo?.caseName}</h2>
                    <SplitDropdownButton
                        isOpen={isOpen}
                        onToggle={toggle}
                        primaryLabel="Case Tools"
                        onPrimaryAction={toggle}
                        menuItems={menuItems}
                    />
                </div>
                <div className="flex items-center gap-2 mb-1">
                    <p className="font-normal not-italic text-base leading-6 tracking-normal mb-1!">
                        {caseTypeText},
                        occurred in {caseData?.caseInfo?.stateOfIncident},
                        on {caseData?.caseInfo?.dateOfIncident} | State Court
                    </p>
                </div>
            </div>
            <div className="flex items-center flex-wrap gap-2">
                <div className="flex items-center gap-2">
                    <span className="text-subtle">Teams</span>
                    {caseData?.teamIds?.length ? (
                        caseData.teamIds.map((team, i) => (
                            <span key={i} className={`badge ${customBadgeClasses}`}>{team?.name}</span>
                        ))
                    ) : (
                        <span className={`badge ${customBadgeClasses}`}>No teams assigned</span>
                    )}
                </div>
                <span className="mx-2 text-body">|</span>
                <div className="flex items-center gap-2">
                    <span className="text-subtle">Case Owners</span>
                    <div className="flex items-center relative">
                        <span className={`badge rounded-full! ${ownerBadgeClasses}`}>{initials}</span>
                        <div className={ownerTooltipClasses}>
                            <div className={tooltipLabelClasses}>Primary Litigator</div>
                            <div className={tooltipNameClasses}>{ownerFullName}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CaseSummaryHeader;
